export const DEFAULT_REQUEST_TIMEOUT = 10 * 1000; // 10 seconds